import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '../../hooks/useAuth';
import { PageLoader } from '../ui/Spinner';
import { useT } from '../../i18n';
import type { TKey } from '../../i18n/ru';

const TITLE_KEYS: Record<string, TKey> = {
  '/': 'nav.dashboard',
  '/channels': 'nav.channels',
  '/courses': 'nav.courses',
  '/calendar': 'page.calendar',
  '/payments': 'nav.payments',
  '/users': 'nav.users',
  '/kicks': 'page.kicks',
  '/payment-methods': 'nav.paymentMethods',
  '/settings': 'nav.settings',
};

export function Layout() {
  const { data: user, isLoading } = useAuth();
  const location = useLocation();
  const t = useT();
  if (isLoading) return <PageLoader />;
  if (!user) return null; // ProtectedRoute уже редиректит

  const titleKey =
    TITLE_KEYS[location.pathname] ?? TITLE_KEYS[`/${location.pathname.split('/')[1]}`];
  const title = titleKey ? t(titleKey) : '';

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar user={user} />
      <div className="flex flex-1 flex-col">
        <Header user={user} title={title} />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
